import { erpAxios } from '..';

const getAllKomitenti = async (uName, officerUsername, skip, take) => {
  const { data } = await erpAxios(`/komitenti/all/${uName}/${officerUsername}/${skip}/${take}`);
  return data;
};

export default getAllKomitenti;
